import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const stepOneReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.STEP_ONE_START:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case types.STEP_ONE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.STEP_ONE_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default stepOneReducer;
